// extracted by mini-css-extract-plugin
export var centerText = "_ef-8";
export var container = "_ef-0";
export var doughnutContainer = "_ef-7";
export var legend = "_ef-a";
export var legendItemColorDisplay = "_ef-b";
export var legendItemLabel = "_ef-d";
export var legendItemValue = "_ef-c";
export var lg = "_ef-5";
export var maxWidth = "_ef-9";
export var md = "_ef-4";
export var responsive = "_ef-6";
export var sm = "_ef-3";
export var xs = "_ef-2";
export var xxs = "_ef-1";